import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'it_IT',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '1216c124-57c4-4a18-bd86-ef1922de35f8',
  ''
);
